<template>
  <router-view />
</template>

<script>
  export default {
    name: "App",
  };
</script>

<style>
/* Reduce table heading and data font size */
.v-table.v-table--hover > .v-table__wrapper > table > tbody > tr > td {

     white-space: nowrap !important;
}
.v-data-table .v-table__wrapper > table > thead > tr > td.v-data-table-column--align-center, .v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-center, .v-data-table .v-table__wrapper > table tbody > tr > td.v-data-table-column--align-center, .v-data-table .v-table__wrapper > table tbody > tr th.v-data-table-column--align-center {
    white-space: nowrap !important;
}
.v-table.v-table--hover > .v-table__wrapper > table > tbody > tr > td {

    border: 1px solid #dee2e6;
        padding: 4px !important;
}

.v-table > .v-table__wrapper > table > tbody > tr > th, .v-table > .v-table__wrapper > table > thead > tr > th, .v-table > .v-table__wrapper > table > tfoot > tr > th {
  border: 1px solid #dee2e6;
      padding: 4px !important;
      text-align: center;
}


.v-data-table-header th,
.v-data-table td {
  font-size: 12px;
}

/* Reduce font size of input fields */
.v-input input,
.v-input__control {
  font-size: 12px;
}

/* Label font (e.g., "Requisition Date") */
.v-label {
  font-size: 12px;
}

/* For autocomplete/dropdown */
.v-select__selection,
.v-select__selections {
  font-size: 13px;
}

</style>
